import { SearchApi, SearchTablesApi } from '@repo/api-gw-sdk';
import type {
  Provider,
  SearchFilesResponse,
  Configuration,
  Condition,
} from '@repo/api-gw-sdk';

import { toJsonText } from '@/components/queryBuilder/QueryLanguageConverter';

import type { HttpClient } from './httpClient';

const baseUrl = '/search';

export const search = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const searchApi = new SearchApi(config);
  const queryDbApi = new SearchTablesApi(config);

  return {
    files: {
      execute: (
        term: string,
        limit: number,
        cloudProvider: Provider,
        queryExecutionId?: string,
        pageToken?: string,
        filters?: Condition,
        startDate?: Date,
        endDate?: Date
      ) =>
        httpClient.execute(
          (...args: Parameters<typeof searchApi.searchFiles>) =>
            searchApi.searchFiles(...args).then(
              (response) => ({
                ...response,
                data: response.data.map((file) => ({
                  ...file,
                  id: file.resourceId + file.path,
                })),
              }),
              (error) => {
                if (error.code === 404) {
                  // nothing - no results found, not an error
                  return {
                    data: [],
                    pagination: {
                      recordsCount: 0,
                      nextToken: undefined,
                      queryExecutionId: undefined,
                    },
                  } satisfies SearchFilesResponse;
                }
                throw error;
              }
            ),
          baseUrl,
          'files',
          currentProjectId,
          {
            cloudProvider,
            query: term,
            limit,
            pageToken,
            queryExecutionId,
            filters: filters ? toJsonText(filters) : undefined,
            startDate,
            endDate,
          }
        ),
    },
    dbs: {
      execute: (
        term: string,
        cloudProvider: Provider,
        queryExecutionId?: string,
        pageToken?: string,
        pageIndex?: number,
        pageSize?: number
      ) =>
        httpClient.execute(
          queryDbApi.searchTables.bind(queryDbApi),
          baseUrl,
          'db',
          currentProjectId,
          {
            cloudProvider,
            query: term,
            queryExecutionId,
            pageToken,
          },
          pageIndex,
          pageSize
        ),
    },
  };
};
